import { render, staticRenderFns } from "./ProjectOrderRead.vue?vue&type=template&id=7f2d270c&scoped=true&"
import script from "./ProjectOrderRead.vue?vue&type=script&lang=js&"
export * from "./ProjectOrderRead.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOrderRead.vue?vue&type=style&index=0&id=7f2d270c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2d270c",
  null
  
)

export default component.exports